import React, { useState, useEffect } from 'react';
import PromotionFloating from './PromotionFloating';
import { X } from 'lucide-react';
import promotionApi from '../../services/promotionApi';

/**
 * Gestionnaire pour afficher plusieurs promotions flottantes
 */
const PromotionsFloatingManager = () => {
  const [promotions, setPromotions] = useState([]);
  const [closedPromotions, setClosedPromotions] = useState(new Set());
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isClosed, setIsClosed] = useState(false);

  useEffect(() => {
    fetchFloatingPromotions();
  }, []);

  const fetchFloatingPromotions = async () => {
    try {
      const data = await promotionApi.getPublicPromotions({
        display_format: 'floating_left',
        status: 'active',
        limit: 10
      });
      setPromotions(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Erreur chargement promotions flottantes:', error);
      setPromotions([]);
    }
  };

  useEffect(() => {
    if (promotions.length <= 1 || isClosed) return;
    const timer = setTimeout(() => {
      setCurrentIndex((prev) => (prev + 1) % promotions.length);
    }, 5 * 1000);
    return () => clearTimeout(timer);
  }, [currentIndex, promotions.length, isClosed]);

  const handleClose = () => setIsClosed(true);

  const handleOrder = (promotion) => {
    if (promotion.restaurant_id) window.location.href = `#/restaurant/${promotion.restaurant_id}`;
  };

  if (promotions.length === 0 || isClosed) return null;

  const currentPromo = promotions[currentIndex];

  return (
    <div className="relative w-full">
      <PromotionFloating
        promotion={currentPromo}
        onClose={handleClose}
        onOrder={handleOrder}
      />
    </div>
  );
};

export default PromotionsFloatingManager;
